export default "__VITE_ASSET__C0Uhs4gE__"